import { Screen } from 'components/screen';
import logginInScreenHTML = require('html-loader!html/logging-in-screen');

export class LoggingInScreen extends Screen {
  public static readonly screenID: string = 'logging-in';

  public async renderImpl(): Promise<void> {
    this.containerEl.innerHTML = logginInScreenHTML;
  }

  protected getTitle() {
    return 'Logging in...';
  }
}
